import {
  CommodityInventorySummary,
  buildNewCommodityInventorySummary,
} from "@/models/CommodityInventorySummary";

interface CommodityInventorySummaryState {
  summaries: CommodityInventorySummary[];
  summary: CommodityInventorySummary;
}

const state: CommodityInventorySummaryState = {
  summaries: [],
  summary: buildNewCommodityInventorySummary(),
};

const mutations = {
  LOAD_COMMODITY_INVENTORY_SUMMARIES(
    state: CommodityInventorySummaryState,
    payload: CommodityInventorySummary[],
  ) {
    state.summaries = payload;
  },

  LOAD_COMMODITY_INVENTORY_SUMMARY(
    state: CommodityInventorySummaryState,
    payload: CommodityInventorySummary,
  ) {
    state.summary = payload;
  },
};

const actions = {
  loadCommodityInventorySummaries(
    context: any,
    items: CommodityInventorySummary[],
  ) {
    return new Promise((resolve, _reject) => {
      context.commit("LOAD_COMMODITY_INVENTORY_SUMMARIES", items);
      resolve(items);
    });
  },

  loadCommodityInventorySummary(context: any, item: CommodityInventorySummary) {
    return new Promise((resolve, _reject) => {
      context.commit("LOAD_COMMODITY_INVENTORY_SUMMARY", item);
      resolve(item);
    });
  },
};

const getters = {
  commodityInventorySummaries: (state: CommodityInventorySummaryState) => {
    return state.summaries;
  },
  commodityInventorySummary: (state: CommodityInventorySummaryState) => {
    return state.summary;
  },
};

const commodityInventorySummariesModule = {
  state,
  mutations,
  actions,
  getters,
};

export default commodityInventorySummariesModule;
